import Masthead from "./components/Masthead";
import Hero from "./components/Hero";
import Meaning from "./components/Meaning";
import Decode from "./components/Decode";
import Compare from "./components/Compare";
import Origin from "./components/Origin";
import Usage from "./components/Usage";
import QuickReference from "./components/QuickReference";
import CopyCard from "./components/CopyCard";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="bg-background-50 text-foreground-900">
      <Masthead />
      <main>
        <Hero />
        <Meaning />
        <Decode />
        <Compare />
        <Origin />
        <Usage />
        <QuickReference />
        <CopyCard />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}